module.exports = __webpack_public_path__ + "img/Transfers.69d8c8b0.svg";